import React from 'react';
import { ArchiveIcon, WarningTriangleIcon, SearchIcon, StarIcon } from '../../icons';

interface EmptyStateProps {
  type?: 'no-data' | 'error' | 'search-no-results' | 'welcome';
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  type = 'no-data',
  icon,
  title,
  description,
  action,
  className = '',
}) => {
  const defaultIcons = {
    'no-data': <ArchiveIcon className="h-16 w-16 text-neutral-400" />,
    error: <WarningTriangleIcon className="h-16 w-16 text-danger-400" />,
    'search-no-results': <SearchIcon className="h-16 w-16 text-neutral-400" />,
    welcome: <StarIcon className="h-16 w-16 text-primary-400" />,
  };

  const displayIcon = icon || defaultIcons[type];

  return (
    <section
      className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    >
      <div className="mb-4" aria-hidden="true">
        {displayIcon}
      </div>
      <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">{title}</h3>
      {description && (
        <p className="text-neutral-600 dark:text-neutral-400 max-w-md mb-6">{description}</p>
      )}
      {action && <div>{action}</div>}
    </section>
  );
};
